export default {
  /*用户上传附件（多文件）*/
  mulUploadFiles: "/api/attachments/multi-upload",
  /*导出附件文件*/
  downLoadAtt: "/api/attachments/download",
  /*获取事项日志列表*/
  getLogLists: (data: any) => {
    return `/api/appproc/packages/self/proc/${data.businessId}/${data.type}/logs`;
  },
  getChildMatterLogLists: (data: any) => {
    return `/api/appproc/packages/self/proc/${data.businessId}/${data.type}/child-matter-logs`;
  },
  /*初始流程数据查询*/
  flowInitRead: () => {
    return `/api/appproc/read/business/fresh-read`;
  },
  /*[初始]流程事项执行发送*/
  sendInitial: () => {
    return `/api/appproc/write/init/send`;
  },
  /*[初始]流程事项执行保存*/
  saveInitial: () => {
    return `/api/appproc/write/init/save`;
  },
  /*待发流程事项查询*/
  getToSendSingle() {
    return `/api/appproc/read/business/wait-read`;
  },
  /*[待发]流程事项带表单执行发送*/
  toSendSendForm() {
    return `/api/appproc/write/wait/send`;
  },
  /*[待发]流程事项带表单执行保存*/
  toSendSaveForm() {
    return `/api/appproc/write/wait/save`;
  },
  /*待办的流程事项查询*/
  getTodoDetail() {
    return `/api/appproc/read/business/todo-read`;
  },
  /*[待办]流程事项执行[提交处理]*/
  sendTodoHasForm() {
    return `/api/appproc/write/todo/submit`;
  },
  /*[待办]流程事项执行[扩展功能]*/
  todoTaskForm() {
    return `/api/appproc/write/todo/func`;
  },
  /*[待办]流程事项执行[编辑]*/
  todoTopEdit() {
    return `/api/appproc/write/todo/edit`;
  },
  /*[待办]流程事项执行[维护]*/
  todoTopAct() {
    return `/api/appproc/write/todo/act`;
  },
  /*[已办]流程事项执行[扩展功能]*/
  doneTaskFunc() {
    return `/api/appproc/write/done/func`;
  },
  /*[已办]流程事项执行[编辑]*/
  doneEditFunc() {
    return `/api/appproc/write/done/edit`;
  },
  /*[已办]流程事项执行[维护]*/
  doneActFunc() {
    return `/api/appproc/write/done/act`;
  },
  /*已发流程事项查询*/
  getSendDetail() {
    return `/api/appproc/read/business/sent-read`;
  },
  /*[已发]流程事项执行[编辑]*/
  sendEditFunc() {
    return `/api/appproc/write/sent/edit`;
  },
  /*[已发]流程事项执行[维护]*/
  sendActFunc() {
    return `/api/appproc/write/sent/act`;
  },
  /*抄送流程事项查询*/
  getCopyDetail() {
    return `/api/appproc/read/business/tocc-read`;
  },
  /*办结流程数据查询*/
  getFinishDetail() {
    return `/api/appproc/read/business/finished-read`;
  },
  /*办结流程数据查询*/
  getViewRead() {
    return `/api/appproc/read/business/view-read`;
  },
  /*已办流程事项查询*/
  getDoneSingle() {
    return `/api/appproc/read/business/done-read`;
  },
  /*终止流程数据查询*/
  getTermSingle() {
    return `/api/appproc/read/business/term-read`;
  },
  /*获取该用户下已被授权的电子签章*/
  getUserSigns() {
    return `/api/system/seals`;
  },
  /*生成签章pdf*/
  setPdfSigns(data: any) {
    return `/api/appproc/packages/${data.pacId}/matters/${data.businessId}/file-pdf/${data.pdfId}`;
  },
  /*获取pdf列表*/
  getPdfList(data: any) {
    return `/api/appproc/packages/${data.pacId}/matters/${data.businessId}/exports`;
  },
  /*获取用户上一条电子签名*/
  getSignNature() {
    return `/api/system/signature`;
  },
  /*创建用户电子签名*/
  setSignNature() {
    return `/api/system/signature`;
  },
  /*[待办、已办、已发]流程事项执行[转发]*/
  transmitProcess() {
    return `/api/appproc/write/transmit`;
  },
  /*[待办-会签]流程事项添加会签人*/
  addMpders() {
    return `/api/appproc/write/todo/add-mpders`;
  },
  /*[待办-会签]流程事项添会签加人*/
  addAdvisers() {
    return `/api/appproc/write/todo/add-advisers`;
  },
  /*[待办]获取常用批示语*/
  getCommonUseOp() {
    return `/api/appproc/phrases`;
  },
  /*[待办]新增常用批示语*/
  addCommonUseOp() {
    return `/api/appproc/oa/addCommonUse`;
  },
  /*[待办]删除常用批示语*/
  delCommonUseOp() {
    return `/api/appproc/oa/deleteCommonUse`;
  },
  /*[待办]修改常用批示语*/
  updateCommonUseOp() {
    return `/api/appproc/oa/changeCommonUse`;
  },
  /*[待办]退回某个节点*/
  rebackProcessNode() {
    return `/api/appproc/oa/returnReceive`;
  },
  /*[待办]获取可退回节点列表*/
  getReturnNodesList() {
    return `/api/appproc/oa/getReturnNodeList`;
  },
  /*[待办、已办]流程事项催办*/
  urgeProcess(businessId: any) {
    return `/api/appproc/write/${businessId}/urge`;
  },
  /*流程图信息*/
  getFlowsTasksInfo(pacId: string, flowCfgId: string, businessId: string) {
    return `/api/appproc/packages/${pacId}/flows/${flowCfgId}/business/${businessId}/tasks/info`;
  },
  /* 获取流程事项待催办人 */
  urgers(businessId: any) {
    return `/api/appproc/read/${businessId}/urgers`;
  }
};
